import React, { Component } from "react";
import Auth from "../../utils/auth";
import * as authService from "../../services/auth/auth-service";
import { withNavigation } from "../../common/hocs";

class Logout extends Component {
  async componentDidMount() {
    await authService.logout();
    Auth.clearAppStorage();
    this.props.navigate("/Login");
  }
  render() {
    return <div></div>;
  }
}

// HOC to inject navigate function
export default withNavigation(Logout);